module.exports = __webpack_public_path__ + "static/media/1.ab89216e.mp3";